module.exports = __webpack_public_path__ + "static/media/40.17292e3d.jpg";